import { useLocation, useNavigate } from "react-router-dom";
import "./requestProduct.css";
import { useState } from "react";
import HeaderOther from "../ui/header-other";

export default function RequestProduct() {
    const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
    const AUTH_TOKEN = process.env.REACT_APP_AUTH_TOKEN;

    const navigate = useNavigate();
    const location = useLocation();

    const [requestText, setRequestText] = useState("");
    const [requestState, setRequestState] = useState(true);

    function home() {
        navigate("/");
    }

    function handleRequest() {
        if (requestText.trim() === "") {
            alert("Please write product name.");
            return;
        }

        setRequestState(false);

        const dataToSend = {
            searchItems: "RequestedWeb - " + requestText
        };

        fetch(`${BACKEND_URL}/search-items`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": `Bearer ${AUTH_TOKEN}`
            },
            body: JSON.stringify(dataToSend)
        })
            .then((response) => response.json())
            .then((data) => {
                console.log(data);
            })
            .catch((error) => {
                console.log(error);
            });
    }

    return (
        <div className="request-product-page">
            <HeaderOther
                title="Request a Product"
                desc="Need something?"
            />

            {requestState ? (
                <div className="request-product-container">
                    <p className="request-product-desc-text">
                        Tell us what product you need, and we’ll do our best
                        to bring it to Freslo for you.
                    </p>

                    <input
                        className="request-product-input"
                        placeholder="🍎 Enter product name"
                        value={requestText}
                        onChange={(e) => setRequestText(e.target.value)}
                    />

                    <div
                        className="request-product-btn"
                        onClick={handleRequest}
                    >
                        <p className="request-product-btn-text">
                            Send Request
                        </p>
                    </div>
                </div>
            ) : (
                <div className="request-product-after-container">
                    <img
                        src="/icons/success.png"
                        alt="success"
                        className="request-product-success-img"
                    />

                    <p className="request-product-after-desc-text">
                        Thank you for your request! Our team will review it
                        and try to add this product to Freslo soon.
                    </p>

                    <p
                        className="request-product-go-home"
                        onClick={home}
                    >
                        Go to Home
                    </p>
                </div>
            )}
        </div>
    );
}